import { useEffect } from 'react'

export const useCommandPaletteHotkey = (toggle: () => void): void => {
    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (
                !(e.metaKey || e.ctrlKey) ||
                e.altKey ||
                e.isComposing ||
                e.key?.toLowerCase() !== 'k'
            ) {
                return
            }

            e.preventDefault()
            toggle()
        }

        window.addEventListener('keydown', handler, { capture: true })
        return () => window.removeEventListener('keydown', handler, { capture: true })
    }, [toggle])
}
